import type { FC, ReactNode } from 'react'

interface NativeLogoProps {
    className: string
    idPrefix: string
}

const LETTERS = [
    'M132.79 54.5803L100.767 19.8163V54.5803H86.27V0.919679H101.56L132.935 35.4673V0.919679H147.359V54.5803H132.79Z',
    'M193.754 33.5921L184.017 11.7384L174.568 33.5921H193.754ZM203.13 54.5803L198.73 44.6271H169.736L165.409 54.5803H150.479L174.28 0.919679H194.186L219.069 54.5803H203.13Z',
    'M234.193 54.5803V13.1808H213.422V0.919679H269.751V13.1808H248.979V54.5803H234.193Z',
    'M290.959 0.919679V54.5803H276.101V0.919679H290.959Z',
    'M339.329 54.5803H319.783L294.9 0.919679H312.21L329.664 41.5979L347.191 0.919679H363.346L339.329 54.5803Z',
    'M367.285 0.919679H416.402V12.6039H381.926V21.3309H415.32V33.4478H381.926V42.7519H416.835V54.5803H367.285V0.919679Z'
]

// The Native mark and wordmark, with the data hooks the preloader animates.
export const NativeLogo: FC<NativeLogoProps> = ({ className, idPrefix }): ReactNode => {
    return (
        <svg className={className} viewBox='0 0 423 55' aria-hidden='true' focusable='false' data-logo=''>
            <defs>
                <clipPath id={`${idPrefix}-logo-cut`}>
                    <rect x='7.86816' y='7.86816' width='43.0124' height='38.8161' />
                </clipPath>
                <clipPath id={`${idPrefix}-logo-word`}>
                    <rect x='60' y='-5' width='380' height='65' />
                </clipPath>
            </defs>
            <g>
                <rect className='logo-fill' width='58.7487' height='54.5524' data-logo-square='' />
                <g clipPath={`url(#${idPrefix}-logo-cut)`}>
                    <rect className='logo-cut' x='7.86816' y='7.86816' width='10.7531' height='38.8161' data-logo-bar='' />
                    <path className='logo-cut' d='M11.8434 14.6708L18.6337 7.8731L50.9028 40.1324L50.8605 46.6892L43.7868 46.6892L11.8434 14.6708Z' data-logo-diag='' />
                    <path className='logo-cut' d='M33.833 7.86816H50.8806V24.9158L42.488 16.5231L33.833 7.86816Z' data-logo-tri='' />
                </g>
            </g>
            <g clipPath={`url(#${idPrefix}-logo-word)`}>
                {LETTERS.map((d) => (
                    <path key={d} className='logo-fill' d={d} data-logo-letter='' />
                ))}
            </g>
        </svg>
    )
}
